import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import RefreshIcon from '@mui/icons-material/Refresh';

interface InputSearchProps {
  label: string;
  defaultValue?: string;
  onSearch: (value: string) => void;
  handleClearInput: () => void; // Recebe a função de limpar como prop
}

const InputSearch: React.FC<InputSearchProps> = ({
  label,
  defaultValue = '',
  onSearch,
  handleClearInput,
}) => {
  const [inputValue, setInputValue] = useState(defaultValue);

  const clearFilterNumberChange = () => {
    setInputValue('');
  };

  // Lidar com as mudanças no input e aplicar a máscara
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setInputValue(value);
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      gap={2}
      justifyContent="space-between"
      sx={{ width: '100%' }}
    >
      <TextField
        value={inputValue}
        onChange={handleInputChange}
        label={label}
        variant="outlined"
        fullWidth
        sx={{
          width: '100%',
          '& .MuiOutlinedInput-input': {
            padding: '10px 14px',
          },
        }}
        slotProps={{
          inputLabel: {
            sx: {
              fontSize: '14px',
              lineHeight: '40px', // Alinha verticalmente com o input
              top: 0,
              transform: 'translate(14px, 0)', // Posição normal (não shrink)
              transition: 'all 0.2s ease', // Transição suave
              '&.MuiInputLabel-shrink': {
                transform: 'translate(14px, -9px) scale(0.75)', // Sobe ao focar ou digitar
                lineHeight: 'normal', // Retira alinhamento vertical no modo shrink
              },
            },
          },
        }}
      />

      {/* Botão de limpar, usa a função recebida via prop */}
      <IconButton
        onClick={() => {
          handleClearInput();
          clearFilterNumberChange();
        }}
        sx={{ padding: 1 }}
      >
        <RefreshIcon />
      </IconButton>

      <Button
        variant="contained"
        onClick={() => onSearch(inputValue)}
        sx={{
          height: '40px',
          alignSelf: 'center',
          paddingX: '30px',
          fontSize: {
            xs: '0.55rem', // Mobile: menor fonte
            sm: '0.875rem', // A partir do sm: tamanho normal
          },
        }}
      >
        Pesquisar
      </Button>
    </Box>
  );
};

export default InputSearch;
